export const dataExperiences = [
    {
        id:1,
        title:"Développeur Web",
        date: "01/10/2022 - 30/09/2023",
        location: "SAFRAN HELICOPTER ENGINES, 64510 Bordes",
        logo: "./images/safranV2.png",
        text:`Contrat d'apprentissage au sein de l'entreprise Safran Helicopter Engines (anciennement Turboméca).`,
        missions: [
            {
                id:1,
                title: "Développement d'une application destinée aux opérateurs",
            },
            {
                id:2,
                title: "Angular, NodeJS, Git, Bootstrap, AG Grid, RxJS, TypeScript",
            }, 
            {
                id:3,
                title: "Méthodes Agiles : SCRUM, Daily, Review, Redmine",
            },
            {
                id:4,
                title: "Compéhension des demandes des métiers et présentation des solutions",
            }
        ]
    },

    {
        id:2,
        title:"Technicien informatique",
        date: "01/10/2020 - 31/09/2022",
        location: "OGEC PRIMAIRE LOURDES, 65100 Lourdes",
        logo: "./images/ogec.jpg",
        text:`Contrat d'apprentissage au sein des écoles privées primaires Massabielle et Immaculée de Soum.`,
        missions: [
            {
                id:1,
                title: "Cours d'informatique aux élèves du primaire",
            },
            {
                id:2,
                title: "Maintenance du parc informatique",
            }, 
            {
                id:3,
                title: "Réalisation de formations sur des outils informatiques",
            },
        ]
    },
    {
        id:3,
        title:"Hôte de caisse",
        date: "01/11/2019 - 31/01/2020",
        location: "GIFI, 65000 Tarbes",
        logo: "./images/gifi.png",

        text:`Contrat étudiant pour les Dimanches.`,
        missions: [
            {
                id:1,
                title: "Enregistrer les achats",
            },
            {
                id:2,
                title: "Controler le fond de caisse",
            }, 
            {
                id:3,
                title: "Ouvertures et fermetures de caisse",
            }, 
        ]
    },
    {
        id:3,
        title:"Technicien informatique",
        date: "01/05/2019 - 15/06/2020",
        location: "CAF des Hautes-Pyrénées, 65000 Tarbes",
        logo: "./images/logo_caf.png",
        text:`Stage d'une durée de 6 semaines.`,
        missions: [
            {
                id:1,
                title: "Configuration et déploiement d'un logiciel des services d'assistance (GLPI)",
            },
            {
                id:2,
                title: "Installation de postes",
            }, 
            {
                id:3,
                title: "Mise à jour de la base de données du matériel",
            }, 
        ]
    },
    {
        id:4,
        title:"Employé de rayon",
        date: "04/03/2019 - 10/03/2019",
        location: "Carrefour Market, 65200 Bagnères-de-Bigorre",
        logo: "./images/carrefour.png",
        text:`Contrat étudiant pour 1 semaine.`,
        missions: [
            {
                id:1,
                title: "Entretenir les espaces de ventes (façing)",
            },
            {
                id:2,
                title: "Disposer des produits sur le lieu de vente",
            }, 
    
        ]
    }
]

export default dataExperiences